import Breadcrumb from "./widget/Breadcrumb";
import FooterThree from "./widget/FooterThree";
import HeaderOne from "./widget/HeaderOne";
import Animation from "../helper/Animation";
import RootLayout from "./layout";
import AboutTwo from "./widget/AboutTwo";
import Slider from "react-slick";
import shape2 from "../assets/images/shapes/shape2.png";
import shape6 from "../assets/images/shapes/shape6.png";


const VisionMission = () => {

  return (
    <>
      <RootLayout>
        {/* Animation */}
        <Animation />

        {/* HeaderTwo */}
        <HeaderOne />

        {/* Breadcrumb */}
        <Breadcrumb title={"Vision & Mission"} />

        <section className="review py-80  overflow-hidden">
          <div className="container">
            <div className="position-relative z-1">
              <img
                src={shape2}
                alt=""
                className="shape two style-left animation-scalation"
              />
              <img
                src={shape6}
                alt=""
                className="shape four style-top animation-scalation"
              />
              <img
                src={shape2}
                alt=""
                className="shape four style-right animation-scalation"
              />
              <div className="row gy-4">
                <div
                  className="col-lg-6"
                  data-aos="fade-up"
                  data-aos-duration={600}
                >
                  <div className="bg-white p-32 rounded-12 box-shadow-md">
                    <h4 className="text-center mb-32">Our Vision</h4>

                    <div className="rounded-12 p-32 transition-2 item-hover bg-main-25 hover-bg-main-600">
                      <p className="text-xl-res item-hover__text transition-2">
                        Within an empowering child-centric environment, through
                        numerous learning opportunities and best teaching
                        practices, we strive to develop socially responsible,
                        independent, knowledgeable, lifelong learners and
                        leaders, equipped with multi-dimensional skills, values
                        and integrity to positively impact and contribute AS
                        GLOBAL CITIZENS.
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  className="col-lg-6"
                  data-aos="fade-up"
                  data-aos-duration={1000}
                >
                  <div className="bg-white p-32 rounded-12 box-shadow-md">
                    <h4 className="text-center mb-32">Our Mission</h4>

                    <div className="rounded-12 p-32  transition-2 item-hover bg-main-25 hover-bg-main-600">
                      <p className="text-xl-res item-hover__text transition-2">
                        <ul className="list-dotted d-flex flex-column gap-14">
                          <li>
                            Continuously evolve teaching learning strategies to
                            equip students with skills and competencies in
                            preparation for their entry into a world beyond
                            School.
                          </li>
                          <li>
                            Provide a plethora of opportunities to all students
                            to develop the 21st century skills to transform
                            themselves into value driven versatile well-grounded
                            individuals.
                          </li>
                          <li>
                            Enhance staff competencies through rigorous
                            professional development programmes laying emphasis
                            on teacher training and leadership training.
                          </li>
                          <li>
                            Continue to build constructive relationships with
                            all our stakeholders thereby creating a positive
                            school climate which helps to extend a caring school
                            community.
                          </li>
                          <li>
                            Enhance IT infrastructure and resources to augment
                            student learning and assessments across scholastic
                            and co-scholastic areas.
                          </li>
                          <li>
                            Strive towards impacting the community undertaking
                            outreach initiatives and environmental projects in
                            the neighbourhood.
                          </li>
                        </ul>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <FooterThree />
      </RootLayout>
    </>
  );
};

export default VisionMission;
